import React, { Component } from "react";
import {Link} from "react-router-dom"
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { register } from '../actions/auth';
import './sign_up_form.css';
import { Redirect } from 'react-router-dom';
import { GoogleSignUpButton } from '../sign_up/components/GoogleSignUpButton';


export class Sign_up_form extends Component{
    state = {
        first_name: '',
        last_name: '',
        phone_number : '',
        email : '',
        username:'',
        password:'',
        occupation:'',
        age:'',
        gender:'',
        instagram_id :'',
        twitter_id :'',
        verification_status:'',
        error: false
    };
    static propTypes = {
        register: PropTypes.func.isRequired,
        isAuthenticated: PropTypes.bool,
      };

 
    onSubmit = e=>{
        e.preventDefault();
        this.props.register(this.state.first_name, this.state.last_name, this.state.phone_number,this.state.email,
          this.state.username,this.state.password,this.state.occupation,parseInt(this.state.age),this.state.gender,
            this.state.instagram_id,this.state.twitter_id,this.state.verification_status);
    }

    onChange = e=> this.setState({ [e.target.name]: e.target.value })

    
    render(){       
        if (this.props.isAuthenticated) {
            return <Redirect to="/" />;
          }
        const { first_name, last_name,phone_number,email,username,password,
        occupation,age,gender,instagram_id,twitter_id}
        =this.state
        
        return(
        <div className="container-sm sign-in-form-container">
            <div className="d-flex justify-content-center headline">
                Sign Up
            </div>

 
            <div className="d-flex justify-content-center content mt-3">
                <form onSubmit={this.onSubmit} data-testid="register">
                <div className="user-details">
              
                            <div className="mb-4 text-start" >
                                <label  className="body">Nama Depan*</label>
                                <input type="text"  className="form-control field" 
                                        onChange={this.onChange} 
                                        name="first_name" 
                                        value={first_name} required/>
                            </div>
                            <div className="mb-4 text-start">
                                <label  className="body">Nama Belakang*</label>
                                <input type="text"  className="form-control field"
                                        onChange={this.onChange} 
                                        name="last_name" 
                                        value={last_name} />
                            </div>
                            <div className="mb-4 text-start">
                                <label  className="body">Nomor Telepon*</label>
                                <input type="tex" pattern="[0-9]{12,13}" maxLength="13" className="form-control field"
                                        onChange={this.onChange}
                                        name="phone_number" 
                                        value={phone_number} required/>
                            </div>
                            <div className="mb-4 text-start">
                                <label  className="body">Email*</label>
                                <input type="email"  className="form-control field" 
                                        onChange={this.onChange} 
                                        name="email" 
                                        value={email}  required/>
                            </div>
                            <div className="mb-4 text-start">
                                <label  className="body">Username*</label>
                                <input type="username"  className="form-control field" 
                                        onChange={this.onChange} 
                                        name="username" 
                                        value={username} required/>
                            </div>
                            <div className="mb-4 text-start">
                                <label  className="body">Password*</label>
                                <input type="password" className="form-control field" 
                                        onChange={this.onChange} 
                                        name="password" 
                                        value={password} required/>
                            </div>
                  
                            <div className="mb-4 text-start">
                                <label  className="body">Pekerjaan</label>
                                <input type="text"  className="form-control field" 
                                    onChange={this.onChange} 
                                    name="occupation" 
                                    value={occupation} />
                            </div>
                            <div className="mb-4 text-start">
                                <label  className="body">Umur*</label>
                                <input type="number"  className="form-control field" 
                                    onChange={this.onChange}
                                    name="age" 
                                    value={age} required />
                            </div>

                            <div className="mb-4 text-start">
                                <label  className="body">Jenis Kelamin*</label>
                                <select className="form-control field"  
                                 onChange={this.onChange}
                                 name="gender"
                                 value={gender} required>
                                    <option value="" disabled={this.props.defaultDisabled ? true : null} ></option>
                                    <option value="Laki-laki">Laki-laki</option>
                                    <option value="Perempuan">Perempuan</option>
                                    <option value="Tidak disebutkan">Tidak disebutkan</option>
                                </select>
                            </div>
                            <div className="mb-4 text-start">
                                <label  className="body">Instagram_id</label>
                                <input type="text"  className="form-control field"
                                    onChange={this.onChange} 
                                    name="instagram_id" 
                                    value={instagram_id}/>
                            </div>
                            <div className="mb-4 text-start">
                                <label  className="body">Twitter</label>
                                <input type="text"  className="form-control field" 
                                    onChange={this.onChange} 
                                    name="twitter_id" 
                                    value={twitter_id} />
                            </div>

                    
                    </div>
                    <div className="d-flex justify-content-center">
                    <button type="submit" className="button button-login">Daftar</button>
                    </div>

                    <div className="d-flex justify-content-center mb-5">
                        <GoogleSignUpButton />
                    </div>
                </form>
                
    

        </div>
     
                <div className="d-flex justify-content-center footnote" >
                    {/* body daftarnya di bold */}
                    <p>Sudah Punya Akun? 
                    <Link to="/login" className="text-decoration-none login">Log In</Link>
                    </p>
                </div>
     </div>
   
    )
        
    
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
  });
  
export default connect(mapStateToProps, { register })(Sign_up_form);